import { ProjectsDto  } from "@gtpl/shared-models/gtpl";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';

export class ProjectsResponseModel extends GlobalResponseObject{
    data?: ProjectsDto;
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: ProjectsDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        // this.data = data;
    }
}
